import {
  BlueVerification,
  CloseIconPrimary,
  GreenVerification,
} from "assets/icons";
import Modal from "components/BaseWidgets/modal";
import React from "react";
import "./style.scss";

const VerificationBadgeModal = ({
  open,
  onCancel,
  idDescription,
  physicalDescription,
}) => {
  const badges = [
    {
      icon: <BlueVerification />,
      title: "ID verification",
      description: idDescription,
    },
    {
      icon: <GreenVerification />,
      title: "Physical verification",
      description: physicalDescription,
    },
  ];

  return (
    <Modal
      isOpen={open}
      className="verification-badge-modal"
      wrapClassName="verification-badge"
      onCancel={onCancel}
      title="Verification badge"
      width={346}
      footer={null}
      closable
      closeIcon={<CloseIconPrimary />}
    >
      <div className="gradient-bg" />
      <div className="modal-content">
        {badges.map(({ icon, title, description }, idx) => (
          <div key={idx} className="badge-wrapper flex gap-2">
            <span className="badge">{icon}</span>
            <div className="badge-content flex flex-col">
              <p className="badge-title fw-600">{title}</p>
              <p className="badge-description">{description}</p>
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default VerificationBadgeModal;
